import React from 'react';
import * as ReactCheckbox from '@radix-ui/react-checkbox';
import { twMerge } from 'tailwind-merge';
export const Checkbox = React.memo((props) => {
    return (<ReactCheckbox.Root {...props} className={`group border-[2px] active:scale-125 duration-150 rounded border-solid size-7 sm:size-5 border-white${props.className ? ` ${props.className}` : ''}`}>
			<ReactCheckbox.Indicator>
				<div className={twMerge('cursor-pointer w-full h-full bg-transparent rounded border-2 motion-safe:duration-150 border-black', props.checked && 'bg-white')}/>
			</ReactCheckbox.Indicator>
		</ReactCheckbox.Root>);
});
